/*portugieser */
export function registerKendoTheme () {
kendo.dataviz.ui.registerTheme('customInsa', 
{   
    "chart": {
        "title": {
            "color": "#686868"
        },
        "legend": {
            "labels": {
                "color": "#686868"
            }
        },
        "chartArea": {
            "background": "#ffffff"
        },
        "seriesDefaults": {
            "labels": {
                "color": "#686868"
            },
       "pie": {
         "overlay": {
             "gradient": "none"
         }
     },
     
     "donut": {
         "overlay": {
             "gradient": "none"
         }
     },
     "column": {
         "overlay": {
             "gradient": "none"
         }
     }
        },
        "axisDefaults": {
            "line": {
                "color": "#9e9e9e"
            },
            "labels": {
                "color": "#686868"
            },
            "minorGridLines": {
                "color": "#e7e7e7"
            },
            "majorGridLines": {
                "color": "#dadada"
            },
            "title": {
                "color": "#686868"
            }
        },
        "seriesColors": [
            "#1C51A0",
            "#184486",
            "#4B6487",
            "#8091AD",
            "#BCC6D7",
            "#979797",
            "#a4a4a4",
            "#575757",
            "#7d7d7d",
            "#e3e3e3"
        ]
    },
    "gauge": {
        "pointer": {
            "color": "#454E7E"
        },
        "scale": {
            "rangePlaceholderColor": "#e7e7e7",
            "labels": {
                "color": "#686868"
            },
            "minorTicks": {
                "color": "#aaaaaa"
            },
            "majorTicks": {
                "color": "#888888"
            },
            "line": {
                "color": "#9e9e9e"
            }
        }
    }
})};



// WEBPACK FOOTER //
// ./insa-css/insa-clients/FIO/insa-kendo-css/kendo.custom.dataviz.ts